import styled, { css } from 'styled-components'

export const Container = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    transition: all 0.2s;


    ${props => props.isOpenModalForms && css`
        display: block;
        z-index: 99;
    `} 

    ${props => props.openSideBar && css`
        display: block;
        z-index: 12;
    `}
`